import { accountsPost } from './api';

export async function addTOSAcknowledgement(orgId, userId, version) {
  try {
    const url = `accounts/addTOSAcknowledgement`;
    const body = {
      orgId,
      userId,
      version,
    };
    const ack = await accountsPost(url, body);

    return ack;
  } catch (error) {
    console.error('Error adding TOS acknowledgement', error);
    return false;
  }
}
